import React from 'react';

import appFormStyles from '../appFormField.module.scss';

import { ToggleComponent } from './toggle.component';
import { ToggleComponentWrapperProps } from './toggleWrapper.component.types';

export const ToggleComponentWrapper = (props: ToggleComponentWrapperProps) => {
  const { isAppFormField, label, required, ...rest } = props;

  return isAppFormField ? (
    <ToggleComponent {...rest} />
  ) : (
    <div className={appFormStyles.appFormField}>
      <div className={appFormStyles.labelWrapper}>
        {label}
        {required && <span>*</span>}
      </div>
      <div className={appFormStyles.inputWrapper}>
        <ToggleComponent {...props} />
      </div>
    </div>
  );
};
